/*
 * Copyright: Infosim GmbH & Co. KG Copyright (c) 2000-2021
 * Company: Infosim GmbH & Co. KG,
 *                  Landsteinerstraße 4,
 *                  97074 Wuerzburg, Germany
 *                  www.infosim.net
 */
export const environment = {
  production: true,
  mode: 'stable',
  CONTENT_URL_PREFIX: 'content',
  WEB_DOCS_FOLDER: 'web-docs',
  INTRODUCTION_FOLDER: 'introduction',
  DOC_FOLDER: 'documentation',
  DOC_SRC_FOLDER: 'resources',
  googleAnalytics: true,
};
